import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import accessory17 from "../../Assets/accessory17.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tab, Nav } from "react-bootstrap";
import "../../App.css";

const Pulley_Wheel_for_Greenhouse = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 63,
      name: "Pulley Wheel for Greenhouse",
      price: 250,
      image: accessory17,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <img
            src={accessory17}
            alt="Poly House Gutter Plate"
            className="d-block w-100"
          />
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">Pulley Wheel for Greenhouse</h2>
            <p className="product-price">
              <a href="/Contact" className="btn btn-link">
                Contact Us for Price Details
              </a>
            </p>
            {/* <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button> */}

            <div className="row mt-4">
              <div className="col-12">
                <p className="text-justify">
                  The Pulley Wheel is an essential component for managing the
                  opening and closing of greenhouse coverings. Designed for
                  smooth operation, this wheel is crafted from high-strength
                  materials, ensuring durability and efficiency.
                </p>
                <i>Note: Minimum Order Quantity: 1000 Units.</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section with Border */}
      <div className="row mt-4">
        <div className="col-12 border-tabs">
          <Tab.Container defaultActiveKey="Specifications">
            <Nav variant="tabs" className="mb-3 custom-nav">
              <Nav.Item>
                <Nav.Link eventKey="Specifications" className="custom-tab">
                  Product Specifications
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Features" className="custom-tab">
                  Features
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="moreInfo" className="custom-tab">
                  Additional Information
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="Specifications">
                <p>
                  <ul>
                    <li>
                      <span className="fw-bold">Material:</span> Galvanized Iron
                      (GI)
                    </li>
                    <li>
                      <span className="fw-bold">Diameter:</span> 4 inches
                    </li>
                    <li>
                      <span className="fw-bold">Weight Capacity:</span> Up to 50
                      kg
                    </li>
                    <li>
                      <span className="fw-bold">Design:</span> Single wheel
                      design for smooth operation
                    </li>

                    <li>
                      <span className="fw-bold">Brand:</span> RGCPL
                    </li>
                    <li>
                      <span className="fw-bold">Durability:</span> 2-3 Years
                    </li>
                    <li>
                      <span className="fw-bold">Minimum Order Quantity:</span>{" "}
                      500 pieces
                    </li>
                  </ul>
                </p>
              </Tab.Pane>

              <Tab.Pane eventKey="Features">
                <h4>Features</h4>
                <ul>
                  <li>
                    Eco-friendly: Manufactured using sustainable practices.
                  </li>
                  <li>
                    Smooth Operation: Facilitates easy movement of greenhouse
                    coverings.
                  </li>
                  <li>
                    Corrosion-resistant: Built to withstand outdoor conditions
                    without degrading.
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="moreInfo">
                <h4>Additional Information</h4>
                <p>
                  <ul>
                    <li>
                      <span className="fw-bold">Item Code:</span> RGCPL-0017
                    </li>
                    <li>
                      <span className="fw-bold">Delivery Time:</span> 7-8 Days
                    </li>
                    <li>
                      <span className="fw-bold">Port of Dispatch:</span>{" "}
                      Maharashtra, India
                    </li>
                    <li>
                      <span className="fw-bold">Production Capacity:</span> 1000
                      Pieces Per Day
                    </li>
                    <li>
                      <span className="fw-bold">Packaging Details:</span> Large
                      Bags
                    </li>
                    <li>
                      <span className="fw-bold">Payment Terms:</span> Advance
                      Payment
                    </li>
                    <li>
                      <span className="fw-bold">Payment Mode:</span> RTGS / NEFT
                      / IMPS
                    </li>
                  </ul>
                </p>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <h5 className="mt-3">Importance of Pulley Wheel for Greenhouse:</h5>
        <p className="text-justify">
          Pulleys are crucial for maintaining an effective ventilation system
          within greenhouses, ensuring optimal conditions for plant growth.
        </p>
        <h5 className="mt-3">Key Benefits of Pulley Wheel for Greenhouse:</h5>

        <p className="text-justify">
          <ul>
            <li>
              Allows for easy adjustment of coverings, vital for regulating
              temperature and humidity levels.
            </li>
            <li>
              Designed to support significant weight while maintaining
              functionality.
            </li>
            <li>
              Easy to install and compatible with various greenhouse systems.
            </li>
          </ul>
        </p>
        <h5 className="mt-3">Applications of Pulley Wheel for Greenhouse:</h5>
        <p className="text-justify">
          <ul>
            <li>
              Used in conjunction with tensioning ropes to open and close
              greenhouse covers.
            </li>
            <li>
              Ideal for automated greenhouse systems requiring mechanical
              operation.
            </li>
          </ul>
        </p>
      </div>

      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Pulley_Wheel_for_Greenhouse;
